import React from 'react';
import {
  Box,
  Container,
  VStack,
  Text,
  Button,
  Icon,
  HStack,
} from '@chakra-ui/react';
import { FiXCircle, FiArrowLeft, FiCreditCard } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import ProfileCard from '../shared/components/ProfileCard';

const CheckoutCancel = () => {
  const navigate = useNavigate();

  return (
    <Box bg="gray.50" minH="100vh" display="flex" alignItems="center" justifyContent="center">
      <Container maxW="md">
        <ProfileCard>
          <VStack spacing={8} textAlign="center" py={12}>
            {/* Cancel Icon */}
            <Box
              w={20}
              h={20}
              borderRadius="full"
              bg="red.50"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon as={FiXCircle} boxSize={10} color="red.500" />
            </Box>

            {/* Cancel Message */}
            <VStack spacing={4}>
              <Text fontSize="2xl" fontWeight="bold" color="gray.800">
                Payment Cancelled
              </Text>
              <Text color="gray.600" lineHeight="1.6">
                Your payment was cancelled and no charges were made to your account.
                You can try again anytime or continue with the free plan.
              </Text>
            </VStack>

            {/* Action Buttons */}
            <VStack spacing={3} w="100%">
              <Button
                leftIcon={<Icon as={FiCreditCard} />}
                colorScheme="orange"
                size="lg"
                w="100%"
                onClick={() => navigate('/pricing')}
              >
                Try Again
              </Button>
              <Button
                leftIcon={<Icon as={FiArrowLeft} />}
                variant="outline"
                size="lg"
                w="100%"
                onClick={() => navigate('/dashboard')}
              >
                Back to Dashboard
              </Button>
            </VStack>

            {/* Support Info */}
            <Text fontSize="xs" color="gray.500" textAlign="center">
              Need help? Contact our support team at support@example.com
            </Text>
          </VStack>
        </ProfileCard>
      </Container>
    </Box>
  );
};

export default CheckoutCancel;